export const getShippingMethodsBase = ({ execute }) => async (cartId) => {
    return execute({
        method: "GET",
        uri: `/ctp/shipping-methods/matching-cart?cartId=${cartId}&expand=zoneRates[*].zone`,
    });
};
